<template>
  <div class="operating-country-tab">
    <div class="operating-country-tab-header">
      <div class="operating-country-tab-title-row">
        <div v-if="showBackButton" class="back-icon" @click="emit('go-back')">
          <v-img
            max-height="24px"
            max-width="24px"
            :src="require('@components/assets/side-bar/backIcon.svg')"
          ></v-img>
        </div>
        <h2 class="operating-country-tab-title">
          Countries used in this account
        </h2>
      </div>
      <p class="operating-country-tab-description">
        This configuration enables features in the Fair Pay module.
      </p>
      <hr class="hr mt-6" />
    </div>
    <!--
      ER-10431: always mount the Vue 3 UniversalTable rebuild so legacy client
      hacks are retired from the live path (scope item d). Legacy file is kept
      for reference/rollback only — not mounted.
    -->
    <OperatingCountryTable
      :countries="countriesOrDataSource"
      :dataSource="dataSource"
      :totalCount="totalCount"
      :externalTotal="externalTotal"
      :serverSidePagination="serverSidePagination"
      :syncedSearchQuery="syncedSearchQuery"
      :dropdownCountryList="dropdownCountryList"
      :operatingCatalogCountryIds="operatingCatalogCountryIds"
      :chatterList="chatterList"
      :totalCheckpointChatter="totalCheckpointChatter"
      v-on="$listeners"
    />
  </div>
</template>

<script setup>
import { computed } from "vue";
import OperatingCountryTable from "@components/OperatingCountryTable/OperatingCountryTable.vue";

const props = defineProps({
  showBackButton: {
    type: Boolean,
    default: false,
  },
  countries: {
    type: Array,
    default: null,
  },
  dataSource: {
    type: Array,
    default: () => [],
  },
  totalCount: {
    type: Number,
    default: 0,
  },
  externalTotal: {
    type: Number,
    default: null,
  },
  serverSidePagination: {
    type: Boolean,
    default: false,
  },
  syncedSearchQuery: {
    type: String,
    default: "",
  },
  dropdownCountryList: {
    type: Array,
    default: () => [],
  },
  operatingCatalogCountryIds: {
    type: Array,
    default: () => [],
  },
  chatterList: {
    type: Array,
    default: () => [],
  },
  totalCheckpointChatter: {
    type: Number,
    default: 0,
  },
});

const emit = defineEmits(["go-back"]);

const countriesOrDataSource = computed(() => {
  if (Array.isArray(props.countries)) return props.countries;
  return props.dataSource || [];
});
</script>

<style scoped>
.hr {
  border: none;
  border-top: 1px solid #eaecf0;
}
.operating-country-tab-title-row {
  display: flex;
  align-items: center;
  gap: 4px;
}
.operating-country-tab-title {
  color: #101828;
  font-family: Inter;
  line-height: 28px;
  font-weight: 600;
  font-size: 18px;
  margin: 0px !important;
}
.operating-country-tab-description {
  overflow: hidden;
  color: #475467;
  text-overflow: ellipsis;
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin: 0px !important;
}
.operating-country-tab {
  width: 100%;
  background-color: #fff;
  border-radius: 12px;
  border: 1px solid #d0d5dd;
  background: #fff;
  box-shadow: 0 1px 2px 0 #10182805;
}
.operating-country-tab-header {
  padding: 16px 14px 0 14px;
  margin-bottom: 10px !important;
}
.back-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 4px;
  border-radius: 100%;
  flex-shrink: 0;
}
.back-icon:hover {
  background-color: #f4f4f4;
}
:deep(.operating-country-table .ex-universal-table-container) {
  border: none !important;
  box-shadow: none !important;
}
:deep(.ex-universal-table-container .table-content) {
  border: none !important;
  /* Keep horizontal inset so Add Country / row menus are not flush to the card edge. */
  padding: 0 16px !important;
}
:deep(.operating-country-table) {
  padding-bottom: 4px;
}
:deep(.ex-country-table-header-text) {
  display: none;
}
:deep(.ex-country-table > .mb-2.ex-country-table-content) {
  display: none;
}
</style>
